import { useState, useEffect, useRef } from 'react';

const socials = [
  { label: 'Facebook',
    icon: <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>,
  },
  { label: 'Instagram',
    icon: <><rect x="2" y="2" width="20" height="20" rx="5"/><path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></>,
  },
  { label: 'WhatsApp',
    icon: <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"/>,
  },
  { label: 'LinkedIn',
    icon: <><path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/><circle cx="4" cy="4" r="2"/></>,
  },
];

const legalContent = {
  Privacidad: {
    title: 'Política de Privacidad',
    sections: [
      {
        heading: '1. Responsable del tratamiento',
        body: 'IBR Perú S.A.C., con RUC 20XXXXXXXXX, domiciliada en Baños del Inca, Cajamarca, Perú, es responsable del tratamiento de sus datos personales recopilados a través de este sitio web y del proyecto "El Alto de los Bosques".',
      },
      {
        heading: '2. Datos que recopilamos',
        body: 'Recopilamos nombre completo, número de teléfono, correo electrónico e información de interés sobre el proyecto inmobiliario, únicamente cuando usted los proporciona de forma voluntaria al contactarnos o completar formularios.',
      },
      {
        heading: '3. Finalidad del tratamiento',
        body: 'Sus datos son utilizados exclusivamente para: (a) responder a sus consultas sobre el proyecto; (b) brindarle información comercial sobre "El Alto de los Bosques"; (c) coordinar visitas o reuniones de presentación; y (d) enviarle actualizaciones del proyecto con su consentimiento previo.',
      },
      {
        heading: '4. Compartición de datos',
        body: 'IBR Perú no comparte, vende ni cede sus datos personales a terceros sin su consentimiento expreso, salvo que sea requerido por autoridades competentes conforme a la legislación peruana vigente (Ley N.º 29733).',
      },
      {
        heading: '5. Derechos del titular',
        body: 'Usted tiene derecho a acceder, rectificar, cancelar u oponerse al tratamiento de sus datos personales en cualquier momento, enviando una solicitud a info@ibrperu.com con el asunto "Protección de Datos".',
      },
      {
        heading: '6. Conservación',
        body: 'Sus datos se conservarán durante el tiempo necesario para cumplir con la finalidad para la que fueron recopilados y, posteriormente, durante los plazos legalmente exigidos.',
      },
    ],
  },
  Términos: {
    title: 'Términos y Condiciones',
    sections: [
      {
        heading: '1. Aceptación',
        body: 'Al acceder y utilizar este sitio web, usted acepta los presentes Términos y Condiciones. Si no está de acuerdo con alguno de ellos, le rogamos que no utilice este sitio.',
      },
      {
        heading: '2. Naturaleza de la información',
        body: 'La información contenida en este sitio web sobre el proyecto "El Alto de los Bosques" tiene carácter exclusivamente informativo y promocional. Las imágenes, renders y descripciones son representaciones artísticas del proyecto en preventa y pueden diferir del producto final.',
      },
      {
        heading: '3. Precios y disponibilidad',
        body: 'Los precios indicados ($155,000 desde) corresponden a valores referenciales de preventa vigentes a la fecha de publicación y están sujetos a cambios sin previo aviso según las condiciones del mercado inmobiliario y el avance del proyecto.',
      },
      {
        heading: '4. Proceso de compra',
        body: 'La reserva o adquisición de una unidad del proyecto está sujeta a la firma de contratos formales, cumplimiento de requisitos legales y financieros, y la normativa inmobiliaria peruana vigente. IBR Perú se reserva el derecho de aceptar o rechazar solicitudes.',
      },
      {
        heading: '5. Propiedad intelectual',
        body: 'Todos los contenidos de este sitio web (textos, imágenes, logotipos, renders y diseños) son propiedad de IBR Perú S.A.C. y están protegidos por las leyes de propiedad intelectual. Queda prohibida su reproducción sin autorización expresa.',
      },
      {
        heading: '6. Limitación de responsabilidad',
        body: 'IBR Perú no se responsabiliza por decisiones de inversión tomadas únicamente en base a la información de este sitio. Se recomienda consultar con un asesor financiero antes de cualquier compromiso de compra.',
      },
    ],
  },
  Cookies: {
    title: 'Política de Cookies',
    sections: [
      {
        heading: '¿Qué son las cookies?',
        body: 'Las cookies son pequeños archivos de texto que se almacenan en su navegador cuando visita un sitio web. Nos ayudan a mejorar su experiencia de navegación y a entender cómo interactúa con nuestro contenido.',
      },
      {
        heading: 'Cookies técnicas (esenciales)',
        body: 'Son necesarias para el funcionamiento básico del sitio. Permiten la navegación y el uso de funciones como los formularios de contacto. No pueden ser desactivadas sin afectar el funcionamiento del sitio.',
      },
      {
        heading: 'Cookies analíticas',
        body: 'Utilizamos herramientas de análisis (como Google Analytics) para recopilar información anónima sobre el comportamiento de los usuarios: páginas visitadas, tiempo de permanencia y origen del tráfico. Esta información nos ayuda a mejorar nuestro sitio y proyecto.',
      },
      {
        heading: 'Cookies de preferencias',
        body: 'Recuerdan sus preferencias de navegación (como el idioma o la región) para ofrecerle una experiencia personalizada en futuras visitas.',
      },
      {
        heading: 'Gestión de cookies',
        body: 'Puede configurar su navegador para rechazar o eliminar cookies en cualquier momento. Tenga en cuenta que desactivar ciertas cookies puede afectar la funcionalidad del sitio. Consulte la ayuda de su navegador (Chrome, Firefox, Safari, Edge) para gestionar sus preferencias.',
      },
      {
        heading: 'Actualizaciones',
        body: 'Esta política puede actualizarse periódicamente para reflejar cambios tecnológicos o legales. La fecha de última actualización es mayo de 2025. Le recomendamos revisarla ocasionalmente.',
      },
    ],
  },
};

function LegalModal({ name, onClose }) {
  const content = legalContent[name];

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center p-4"
      style={{ background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(4px)' }}
      onClick={onClose}
    >
      <div
        className="relative bg-white rounded-3xl w-full max-w-2xl max-h-[80vh] flex flex-col shadow-2xl"
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-8 pt-7 pb-5 border-b border-gray-100">
          <h2 className="text-xl font-bold text-black">{content.title}</h2>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center
              hover:bg-gray-200 transition-colors duration-200 flex-shrink-0"
            aria-label="Cerrar"
          >
            <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>

        {/* Body — scrollable */}
        <div className="overflow-y-auto px-8 py-6 flex flex-col gap-5">
          {content.sections.map((s) => (
            <div key={s.heading}>
              <h3 className="text-sm font-semibold text-black mb-1.5">{s.heading}</h3>
              <p className="text-sm text-gray-500 leading-relaxed font-light">{s.body}</p>
            </div>
          ))}
          <p className="text-xs text-gray-300 pt-2">IBR Perú S.A.C. · info@ibrperu.com · Baños del Inca, Cajamarca, Perú</p>
        </div>
      </div>
    </div>
  );
}

export default function Footer() {
  const [modal, setModal] = useState(null);
  const brandRef = useRef(null);

  useEffect(() => {
    const fit = () => {
      const el = brandRef.current;
      if (!el) return;
      el.style.fontSize = '10px';
      el.style.width = 'max-content';
      const textWidth = el.scrollWidth;
      const containerWidth = el.parentElement.clientWidth;
      el.style.width = '100%';
      el.style.fontSize = (10 * containerWidth / textWidth) + 'px';
    };
    document.fonts.ready.then(fit);
    window.addEventListener('resize', fit);
    return () => window.removeEventListener('resize', fit);
  }, []);

  return (
    <>
      <footer style={{ backgroundColor: '#000', color: '#eaf0e9' }}>
        <div className="px-8 md:px-16 pt-16 pb-8">

          {/* Top row */}
          <div className="flex flex-col md:flex-row justify-between gap-10 pb-12"
            style={{ borderBottom: '1px solid rgba(234,240,233,0.12)' }}>
            {/* Brand */}
            <div className="max-w-xs">
              <div className="flex items-center gap-2.5 mb-4">
                <svg viewBox="0 0 80 72" className="w-8 h-7" fill="none" strokeLinejoin="miter">
                  <rect x="30" y="6" width="20" height="54" fill="#C8CDD4"/>
                  <rect x="36" y="14" width="8" height="16" fill="#0F0F0F"/>
                  <path d="M8 60 L8 32 L26 22 L26 60" stroke="#eaf0e9" strokeWidth="1.8"/>
                  <path d="M46 60 L46 36 L60 24 L74 36 L74 60" stroke="#eaf0e9" strokeWidth="1.8"/>
                  <line x1="4" y1="60" x2="78" y2="60" stroke="#eaf0e9" strokeWidth="1.8"/>
                </svg>
                <div>
                  <div className="text-xs font-semibold tracking-[.22em] uppercase" style={{ color: '#eaf0e9' }}>IBR PERÚ</div>
                  <div className="text-[9px] tracking-[.36em] uppercase" style={{ color: 'rgba(234,240,233,0.45)' }}>BIENES RAÍCES</div>
                </div>
              </div>
              <p className="text-sm leading-relaxed font-light" style={{ color: 'rgba(234,240,233,0.65)' }}>
                Tu aliado de confianza en bienes raíces. Más de 7 años desarrollando proyectos inmobiliarios de alta calidad en el Perú.
              </p>
            </div>

            {/* Links */}
            <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
              <div>
                <h5 className="text-xs font-semibold tracking-wider uppercase mb-4" style={{ color: '#eaf0e9' }}>El Proyecto</h5>
                <ul className="flex flex-col gap-2.5">
                  {['El Concepto','Ubicación','Comodidades','Especificaciones'].map(l => (
                    <li key={l}>
                      <a href="#" className="text-sm transition-colors"
                        style={{ color: 'rgba(234,240,233,0.55)' }}
                        onMouseEnter={e => e.target.style.color = '#eaf0e9'}
                        onMouseLeave={e => e.target.style.color = 'rgba(234,240,233,0.55)'}>{l}</a>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h5 className="text-xs font-semibold tracking-wider uppercase mb-4" style={{ color: '#eaf0e9' }}>Inversión</h5>
                <ul className="flex flex-col gap-2.5">
                  {['Precios Preventa','Planes de Pago','Retorno Airbnb','Documentación'].map(l => (
                    <li key={l}>
                      <a href="#" className="text-sm transition-colors"
                        style={{ color: 'rgba(234,240,233,0.55)' }}
                        onMouseEnter={e => e.target.style.color = '#eaf0e9'}
                        onMouseLeave={e => e.target.style.color = 'rgba(234,240,233,0.55)'}>{l}</a>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h5 className="text-xs font-semibold tracking-wider uppercase mb-4" style={{ color: '#eaf0e9' }}>Contacto</h5>
                <ul className="flex flex-col gap-2.5 text-sm">
                  <li><a href="mailto:info@ibrperu.com" style={{ color: 'rgba(234,240,233,0.55)' }}
                    onMouseEnter={e => e.target.style.color = '#eaf0e9'}
                    onMouseLeave={e => e.target.style.color = 'rgba(234,240,233,0.55)'}>info@ibrperu.com</a></li>
                  <li><a href="tel:+51965194210" style={{ color: 'rgba(234,240,233,0.55)' }}
                    onMouseEnter={e => e.target.style.color = '#eaf0e9'}
                    onMouseLeave={e => e.target.style.color = 'rgba(234,240,233,0.55)'}>(+51) 965 194 210</a></li>
                  <li><a href="https://www.ibrperu.com" target="_blank" rel="noopener noreferrer"
                    style={{ color: 'rgba(234,240,233,0.55)' }}
                    onMouseEnter={e => e.target.style.color = '#eaf0e9'}
                    onMouseLeave={e => e.target.style.color = 'rgba(234,240,233,0.55)'}>www.ibrperu.com</a></li>
                  <li className="text-xs pt-1" style={{ color: 'rgba(234,240,233,0.3)' }}>Baños del Inca · Cajamarca · Perú</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Bottom row */}
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8">
            <p className="text-xs" style={{ color: 'rgba(234,240,233,0.35)' }}>&copy; {new Date().getFullYear()} IBR Perú. Todos los derechos reservados.</p>

            <div className="flex gap-3">
              {socials.map((s) => (
                <button key={s.label}
                  className="w-8 h-8 rounded-full flex items-center justify-center transition-all duration-200 hover:scale-110"
                  style={{ border: '1px solid rgba(234,240,233,0.2)', color: 'rgba(234,240,233,0.45)' }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = '#eaf0e9'; e.currentTarget.style.color = '#eaf0e9'; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(234,240,233,0.2)'; e.currentTarget.style.color = 'rgba(234,240,233,0.45)'; }}>
                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth={1.8}
                    strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                    {s.icon}
                  </svg>
                </button>
              ))}
            </div>

            <div className="flex gap-5 text-xs" style={{ color: 'rgba(234,240,233,0.35)' }}>
              {['Privacidad','Términos','Cookies'].map(l => (
                <button key={l}
                  className="transition-colors hover:underline"
                  style={{ color: 'rgba(234,240,233,0.35)', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
                  onMouseEnter={e => e.target.style.color = '#eaf0e9'}
                  onMouseLeave={e => e.target.style.color = 'rgba(234,240,233,0.35)'}
                  onClick={() => setModal(l)}
                >{l}</button>
              ))}
            </div>
          </div>

        {/* ── Big brand name ── */}
        <div className="overflow-hidden mt-8">
          <p ref={brandRef} style={{
            fontWeight: 800,
            lineHeight: 0.85,
            letterSpacing: 0,
            color: 'rgba(234,240,233,0.06)',
            userSelect: 'none',
            whiteSpace: 'nowrap',
            display: 'block',
            width: '100%',
          }}>
            IBR PERÚ
          </p>
        </div>

        </div>{/* /px-8 wrapper */}
      </footer>

      {modal && <LegalModal name={modal} onClose={() => setModal(null)} />}
    </>
  );
}
